<template>
<div class="avatarpicker">
    <ul class="nav nav-tabs modal-nav site-bg" v-if="pages.length > 1">
        <li v-for="page in pages" :key="page.name" :class="{ 'active': currentPage === page.name }">
            <a href="#" @click.prevent="changePage(page.name)"><i :class="['fa', 'fa-' + page.icon]"></i> {{ page.text }}</a>
        </li>
    </ul>
    <div v-if="currentPage === 'photos' && myphotos.length" class="avatarpicker-photos">
        <media v-for="photo in myphotos" :key="photo.id" :media="photo" :card="false" :stats="false" @click.native="select(photo)"></media>
    </div>
    <div v-else-if="currentPage === 'upload'" id="media-upload">
        <upload :maxFiles="1" :maxSetFiles="1" mediaType="photo" :album="publicAlbum" :isAvatar="true" :set="1"
            @media-upload-complete="uploadComplete" ref="upload"></upload>
    </div>
    <span v-else-if="currentPage === 'photos' && !loading">{{ t.cover_image_no_photos }}</span>
    <loading v-if="loading"></loading>
</div>
</template>

<script>
import Media from 'Media/component/Media.vue';
import Upload from 'Media/component/MediaUpload.vue';
import { mapState } from 'vuex';
import ajax from '../js/util/ajax.fetch';
import Loading from './Loading.vue';

export default {
    name: 'AvatarPicker',
    components: {
        Loading,
        Media,
        Upload
    },
    computed: {
        ...mapState({
            t: state => state.t
        }),
        pages() {
            const pages = [];
            if (!this.hideMyPhotos) {
                pages.push({ name: 'photos', text: this.t.my_photos, icon: 'user' });
            }
            if (this.publicAlbum && this.showUpload) {
                pages.push({ name: 'upload', text: this.t.upload, icon: 'user' });
            }
            return pages;
        },
        showUpload() {
            return parseInt(this.$store.state.config.data.userId, 10) === parseInt(this.$store.state.siteConfig.user.id, 10);
        },
        user() {
            return this.$store.state.config.data.userId || this.$store.state.siteConfig.user.id;
        }
    },
    data() {
        return {
            currentPage: this.hideMyPhotos ? 'upload' : 'photos',
            myphotos: [],
            loading: false
        };
    },
    methods: {
        changePage(page) {
            this.currentPage = page;
        },
        load() {
            this.$children.forEach((child) => {
                child.$emit('reset');
            });
            if (this.myphotos.length || this.hideMyPhotos) {
                return;
            }
            this.loading = true;

            const type = [0];
            if (this.isClub) {
                type.push(2);
            }

            ajax.get(
                'media',
                {
                    user: this.user,
                    set: 1,
                    approved: 1,
                    deleted: 0,
                    public: 1,
                    adult: 0,
                    type
                }
            ).then((response) => {
                this.loading = false;
                this.myphotos = this.myphotos.concat(response.items);
            });
        },
        reset() {
            this.$refs.upload.reset();
        },
        /** Triggered when a media item has been selected
         * @event changeavatar
         * @type {Object}
         */
        select(mediaItem) {
            this.$emit('changeavatar', mediaItem);
        },
        /** Triggered when an upload finishes
         * @event changeavatar
         * @type {Object}
         */
        uploadComplete(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.$emit('changeavatar', e.target.result);
            };
            reader.readAsDataURL(file);
        }
    },
    mounted() {
        this.$on('show', this.load);
    },
    props: {
        hideMyPhotos: {
            type: Boolean,
            default: false
        },
        isClub: {
            type: Boolean,
            default: false
        },
        publicAlbum: {
            type: Number
        }
    }
};

</script>

<style lang="scss">
.avatarpicker-photos {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    margin: -15px;
}
</style>
